import { immer } from "zustand/middleware/immer";

import { User } from "@/types";
import { createStore } from "@/utils";

type LikeState = {
  changedLikes: Record<User["id"], boolean>;
};

type LikeActions = {
  actions: {
    changeUsersLike: (data: { userId: User["id"]; value: boolean }) => void;
    isUserIdChanged: (userId: User["id"]) => boolean;
  };
};

const defaultLikeValues: LikeState = {
  changedLikes: {},
};

const useLikeStore = createStore<LikeState & LikeActions>(
  immer((set, get) => ({
    ...defaultLikeValues,
    actions: {
      changeUsersLike: ({ userId, value }) =>
        set((state) => {
          if (userId in state.changedLikes) {
            state.changedLikes[userId] = !state.changedLikes[userId];
          } else {
            state.changedLikes[userId] = value;
          }
        }),
      isUserIdChanged: (userId) => {
        const state = get();
        return userId in state.changedLikes;
      },
    },
  }))
);

export { useLikeStore };
